import showSavedJobsCount from "./show-saved-jobs-count";

const setSavedJobsIcon = () => {
	const savedJobsLocalstorage = JSON.parse(localStorage.getItem(`careerSavedJobsID_${lang}`));

	if(savedJobsLocalstorage) {
		for(let id of savedJobsLocalstorage) {
			const jobResult = document.querySelectorAll(`[data-ghid="${id}"]`)[0];

			if(jobResult) {
				const result = jobResult.offsetParent;
				const saveJobButton = result.lastElementChild;

				setTimeout(() => {
					saveJobButton.classList.add('is-saved');
					saveJobButton.setAttribute('data-job-is-saved', true);
				}, 250);
			}
		}

		setTimeout(() => {
			showSavedJobsCount({
				onload: true
			});
		}, 250);
	}
};

export default setSavedJobsIcon;